import React from "react";
import { Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SummaryFloatingActionButtonsProps {
  showTranslation: boolean;
  onToggleTranslation: () => void;
  isGeneratingTranslation: boolean;
}

export const SummaryFloatingActionButtons: React.FC<SummaryFloatingActionButtonsProps> = ({
  showTranslation,
  onToggleTranslation,
  isGeneratingTranslation,
}) => {
  return (
    <div className="fixed right-2 sm:right-12 top-[420px] flex flex-col gap-2 z-40">
      {/* Translation Toggle */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className={`h-8 w-8 sm:h-10 sm:w-10 rounded-[10px] sm:rounded-xl ${
                showTranslation
                  ? "bg-primary hover:bg-primary text-primary-foreground"
                  : "dark:bg-primary/30 hover:bg-gray-50"
              } shadow-sm`}
              onClick={onToggleTranslation}
              disabled={isGeneratingTranslation}
            >
              {isGeneratingTranslation ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
              ) : (
                <Languages size={14} className={showTranslation ? "text-primary-foreground" : ""} />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <div className="max-w-[200px]">
              <p className="font-semibold">
                {isGeneratingTranslation ? 'Generating...' : (showTranslation ? "Hide" : "Show")} Translation
              </p>
              <p className="text-xs mt-1 text-gray-400">
                Chinese translation of the summary
              </p>
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};